import React from 'react';
import { ThemeProvider } from 'styled-components';
import buildSpindleTheme from '../helpers/buildSpindleTheme.js';

function SpindleThemeProvider(_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? buildSpindleTheme() : _b,
      children = _a.children;
  return React.createElement(ThemeProvider, {
    theme: theme
  }, children);
}

export { SpindleThemeProvider as default };